import {
  ChannelManager,
  ROOMCLOUD_CHANNEL_MANAGER,
} from 'app/typings/channelManagers';
import { getSortedChannelManagersByImportance } from 'app/utils/channelManagerSort';
import { getDerbysoftSuppliersDataSource } from 'app/utils/channelManagers/derbysoft';

import { ChannelManagerTag } from '../../../../../_components/ChannelManagerTag/ChannelManagerTag';
import styles from '../StepIntro.module.scss';

import { OptionCard } from './OptionCard';

type ChannelManagerOptionProps = {
  onClick: () => void;
};

export const ChannelManagerOption = ({
  onClick,
}: ChannelManagerOptionProps) => (
  <OptionCard
    category="OPTION 1"
    title="Connect to your Channel Manager"
    subtitle="For real-time inventory and pricing sync."
    buttonLabel="Request connection"
    onButtonClick={onClick}
  >
    <div className={styles.children}>
      {getSortedChannelManagersByImportance(
        [
          ...Object.values(ChannelManager),
          ...Object.values(ROOMCLOUD_CHANNEL_MANAGER),
        ].filter(
          (channelManager) =>
            channelManager !== ChannelManager.NONE &&
            channelManager !== ChannelManager.DERBYSOFT
        )
      ).map((channelManager) => (
        <ChannelManagerTag key={channelManager} variant={channelManager} />
      ))}
      {getDerbysoftSuppliersDataSource().map((supplier) => (
        <ChannelManagerTag
          key={supplier.id}
          variant={ChannelManager.DERBYSOFT}
          supplierId={supplier.id}
        />
      ))}
    </div>
  </OptionCard>
);
